export default __webpack_public_path__ + "static/media/Header.80003c55.png";